import React from 'react';
import styled from 'styled-components';

import Picture from '../../../../containers/assets/instructor-onboarding-image16.png';

const Wrapper = styled.div`
  background: #f5f6f7;
  flex: 1;
`;

const Container = styled.div`
  padding: 40px;
  width: 80%;
  max-width: 794px;
`;

const Text1 = styled.div`
  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 16px;
  color: rgba(0, 27, 59, 0.38);
  text-transform: uppercase;
`;

const Text2 = styled.div`
  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 700;
  font-size: 21px;
  line-height: 28px;
  color: rgba(0, 27, 59, 0.94);
  margin-top: 24px;
`;

const Text3 = styled.div`
  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: rgba(0, 27, 59, 0.6);
  margin-top: 12px;

  b {
    color: #ed716d;

    &.black-note {
      color: rgba(0, 27, 59, 0.94);
    }
  }
`;

const Image = styled.div`
  display: flex;
  margin-top: 12px;
`;

const HowGradingWorksStep4 = () => (
  <Wrapper>
    <Container>
      <Text1>How Grading Works</Text1>
      <Text2>Engagement Score</Text2>
      <Text3>
        A student's engagement score is based on their level of engagement with the
        research data in the game. If they review all of the relevant content (e.g.
        business case, customer analysis, team reports), then they'll receive an
        engagement score of 100%.
      </Text3>

      <Image>
        <img src={Picture} alt="" />
      </Image>
    </Container>
  </Wrapper>
);

export default HowGradingWorksStep4;



// WEBPACK FOOTER //
// ./src/instructor/components/onboarding/how-grading-works/step4.js